import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'trustHtml',
})
export class TrustHtmlPipe implements PipeTransform {
  private domSanitized: DomSanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    return this.domSanitized.bypassSecurityTrustHtml(value);
  }
}
